<div [class]="addClass">
  {{title}}
  <div style.background-image="url('{{imageUrl}}')" class="img-container"></div>
  <div class="link" *ngIf="info === undefined" (dblclick)="$event.preventDefault()" (click)="linkClicked.emit(); $event.stopPropagation()"><img *ngIf="link" src="assets/icon/buttons/arrow.svg"><span>{{link}}</span></div>
  <div class="info" *ngIf="info">{{info}}</div>
</div>
